import { LoanPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/entities/PaymentMethodDetail/LoanPaymentMethodDetailEntity';
import { CustomRequiredFile } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/_shared/types';
import { RequiredFilesDocumentGroup } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/components/RequiredFilesDocumentGroup';
import { useRequiredFilesDocumentGroups } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/UploadDocuments/hooks/useRequiredFilesDocumentGroups';
import { FlexColumn } from '@/components/shared/components/FlexColumn';

interface PendingDocumentsSectionProps {
  files: CustomRequiredFile[];
  paymentMethodDetailEntity: LoanPaymentMethodDetailEntity;
}

export const PendingDocumentsSection = ({ files, paymentMethodDetailEntity }: PendingDocumentsSectionProps) => {
  const documentGroups = useRequiredFilesDocumentGroups({
    files,
    paymentMethodDetailEntity,
    sortMode: 'pending',
  });

  return (
    <FlexColumn gridGap={16} justifyContent={'center'} width={'100%'}>
      {documentGroups.map(({ groupKey, titleSuffix, files: groupFiles }) => (
        <RequiredFilesDocumentGroup
          key={groupKey}
          groupKey={groupKey}
          titleSuffix={titleSuffix}
          files={groupFiles}
          paymentMethodDetailEntity={paymentMethodDetailEntity}
        />
      ))}
    </FlexColumn>
  );
};
